import React, { useState } from 'react'

export default function ContactCards() {
  const [copied, setCopied] = useState(false)

  const copyAddress = () => {
    navigator.clipboard?.writeText('Biofuel Technology Global, Bredkaer Parkvej 58, 8250 Egaa, Denmark')
    setCopied(true)
    setTimeout(() => setCopied(false), 2500)
  }

  const contacts = [
    {
      name: 'Torben A. Bonde',
      role: 'Founder and owner',
      email: 'tab@biofuelglobal.dk',
      initials: 'TB',
      secondaryEmail: {
        label: 'Partner contact (Kinetic Biofuel)',
        email: 'tab@kineticbiofuel.com',
      },
    },
    {
      name: 'Peter Taylor',
      role: 'Co-founder and co-owner',
      email: 'pta@biofuelglobal.dk',
      initials: 'PT',
    },
  ]

  return (
    <section id="contact" className="py-12 sm:py-16 bg-[#080f0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-10 sm:mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-[#122419] border border-[#1f3f2a] text-xs font-semibold uppercase tracking-wider text-emerald-300 mb-3">
            <i className="fa-solid fa-address-book text-xs" aria-hidden="true" />
            <span>Direct Inquiries</span>
          </div>
          <h2 className="text-2xl sm:text-4xl font-bold text-white tracking-tight">
            Key Contacts & Location
          </h2>
          <p className="mt-3 text-sm sm:text-base text-neutral-400">
            Reach out directly to executive management for partnerships, technical dialogue, or business inquiries.
          </p>
        </div>

        {/* Contact Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {/* Founder 1: Torben A. Bonde */}
          <div className="bg-[#0e1b13] border border-[#1b3624] rounded-2xl p-6 sm:p-7 flex flex-col justify-between">
            <div>
              <div className="flex items-center justify-between mb-5">
                <div className="w-12 h-12 rounded-xl bg-[#14281c] border border-emerald-500/20 text-emerald-300 flex items-center justify-center font-bold text-lg">
                  TB
                </div>
                <span className="px-2.5 py-1 rounded-full text-[11px] font-semibold bg-emerald-950/70 border border-emerald-800/50 text-emerald-300">
                  Leadership
                </span>
              </div>
              <h3 className="text-xl font-bold text-white tracking-tight">
                Torben A. Bonde
              </h3>
              <p className="text-sm font-medium text-emerald-400 mt-1">
                Founder and owner
              </p>
              <div className="mt-6 pt-5 border-t border-[#183121] space-y-3">
                <div>
                  <span className="text-[11px] uppercase tracking-wider text-neutral-400 font-semibold block mb-1">
                    Primary Email
                  </span>
                  <a
                    href="mailto:tab@biofuelglobal.dk"
                    className="inline-flex items-center gap-2 text-sm sm:text-base font-semibold text-white hover:text-emerald-400 transition-colors whitespace-nowrap"
                  >
                    <i className="fa-solid fa-envelope text-emerald-400 text-xs" aria-hidden="true" />
                    <span>tab@biofuelglobal.dk</span>
                  </a>
                </div>
                <div className="pt-2">
                  <span className="text-[11px] uppercase tracking-wider text-neutral-400 font-semibold block mb-1">
                    Partner Email (Kinetic Biofuel)
                  </span>
                  <a
                    href="mailto:tab@kineticbiofuel.com"
                    className="inline-flex items-center gap-2 text-xs sm:text-sm font-medium text-emerald-300 hover:text-emerald-200 transition-colors whitespace-nowrap"
                  >
                    <i className="fa-solid fa-paper-plane text-emerald-500 text-[10px]" aria-hidden="true" />
                    <span>tab@kineticbiofuel.com</span>
                  </a>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-5 border-t border-[#183121]">
              <a
                href="mailto:tab@biofuelglobal.dk"
                className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl font-semibold text-xs sm:text-sm text-neutral-950 bg-emerald-400 hover:bg-emerald-300 transition-colors shadow-sm"
              >
                <i className="fa-solid fa-paper-plane text-xs" aria-hidden="true" />
                <span>Send Email to Torben</span>
              </a>
            </div>
          </div>

          {/* Founder 2: Peter Taylor */}
          <div className="bg-[#0e1b13] border border-[#1b3624] rounded-2xl p-6 sm:p-7 flex flex-col justify-between">
            <div>
              <div className="flex items-center justify-between mb-5">
                <div className="w-12 h-12 rounded-xl bg-[#14281c] border border-emerald-500/20 text-emerald-300 flex items-center justify-center font-bold text-lg">
                  PT
                </div>
                <span className="px-2.5 py-1 rounded-full text-[11px] font-semibold bg-emerald-950/70 border border-emerald-800/50 text-emerald-300">
                  Leadership
                </span>
              </div>
              <h3 className="text-xl font-bold text-white tracking-tight">
                Peter Taylor
              </h3>
              <p className="text-sm font-medium text-emerald-400 mt-1">
                Co-founder and co-owner
              </p>
              <div className="mt-6 pt-5 border-t border-[#183121] space-y-3">
                <div>
                  <span className="text-[11px] uppercase tracking-wider text-neutral-400 font-semibold block mb-1">
                    Primary Email
                  </span>
                  <a
                    href="mailto:pta@biofuelglobal.dk"
                    className="inline-flex items-center gap-2 text-sm sm:text-base font-semibold text-white hover:text-emerald-400 transition-colors whitespace-nowrap"
                  >
                    <i className="fa-solid fa-envelope text-emerald-400 text-xs" aria-hidden="true" />
                    <span>pta@biofuelglobal.dk</span>
                  </a>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-5 border-t border-[#183121]">
              <a
                href="mailto:pta@biofuelglobal.dk"
                className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl font-semibold text-xs sm:text-sm text-neutral-950 bg-emerald-400 hover:bg-emerald-300 transition-colors shadow-sm"
              >
                <i className="fa-solid fa-paper-plane text-xs" aria-hidden="true" />
                <span>Send Email to Peter</span>
              </a>
            </div>
          </div>

          {/* Location / Headquarters Card */}
          <div className="bg-[#0e1b13] border border-[#1b3624] rounded-2xl p-6 sm:p-7 flex flex-col justify-between md:col-span-2 lg:col-span-1">
            <div>
              <div className="flex items-center justify-between mb-5">
                <div className="w-12 h-12 rounded-xl bg-[#14281c] border border-emerald-500/20 text-emerald-300 flex items-center justify-center text-lg">
                  <i className="fa-solid fa-location-dot" aria-hidden="true" />
                </div>
                <span className="px-2.5 py-1 rounded-full text-[11px] font-semibold bg-emerald-950/70 border border-emerald-800/50 text-emerald-300">
                  Headquarters
                </span>
              </div>
              <h3 className="text-xl font-bold text-white tracking-tight">
                Biofuel Technology Global
              </h3>
              <p className="text-sm font-medium text-emerald-400 mt-1">
                Denmark
              </p>

              <div className="mt-6 pt-5 border-t border-[#183121]">
                <span className="text-[11px] uppercase tracking-wider text-neutral-400 font-semibold block mb-2">
                  Registered Address
                </span>
                <address className="not-italic text-sm sm:text-base text-neutral-200 leading-relaxed space-y-1">
                  <div className="font-semibold text-white">Biofuel Technology Global</div>
                  <div>Bredkaer Parkvej 58</div>
                  <div>8250 Egaa, Denmark</div>
                </address>
              </div>
            </div>

            <div className="mt-8 pt-5 border-t border-[#183121] flex items-center gap-3">
              <button
                type="button"
                onClick={copyAddress}
                className="flex-1 inline-flex items-center justify-center gap-2 px-3 py-2.5 rounded-xl font-semibold text-xs text-white bg-[#14291c] hover:bg-[#1c3826] border border-[#234b33] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400"
              >
                <i className={`fa-solid ${copied ? 'fa-check text-emerald-400' : 'fa-copy'} text-xs`} aria-hidden="true" />
                <span>{copied ? 'Address Copied!' : 'Copy Address'}</span>
              </button>
              <a
                href="https://maps.google.com/?q=Bredkaer+Parkvej+58,+8250+Egaa,+Denmark"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center p-2.5 rounded-xl text-neutral-300 hover:text-white bg-[#14291c] hover:bg-[#1c3826] border border-[#234b33] transition-colors"
                title="Open in Google Maps"
                aria-label="Open in Google Maps"
              >
                <i className="fa-solid fa-map-location-dot text-sm text-emerald-400" aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
